"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllDeviceData = exports.getHDM = exports.getJavascriptData = void 0;
var constants_1 = require("../constants");
var utilities_1 = require("../utilities");
var getValueByElementId = function (id) {
    return new Promise(function (resolve, reject) {
        var el = document.getElementById(id);
        if (el && el.value) {
            resolve(el.value);
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('');
    });
};
var getJavascriptData = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, utilities_1.retryOperation(function () { return getValueByElementId(constants_1.DEVICE_PRINT_USER_PREFS_ID); }, 100, 25).catch(function () {
                // To keep functionality BAU, this is allowed to fail and return an empty string
                return '';
            })];
    });
}); };
exports.getJavascriptData = getJavascriptData;
var getHDM = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, utilities_1.retryOperation(function () { return getValueByElementId(constants_1.DEVICE_PRINT_USER_PREFS2_ID); }, 100, 25).catch(function () {
                // To keep functionality BAU, this is allowed to fail and return an empty string
                return '';
            })];
    });
}); };
exports.getHDM = getHDM;
var getAllDeviceData = function () { return __awaiter(void 0, void 0, void 0, function () {
    var javascriptData, hdmJavascriptData, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4 /*yield*/, exports.getJavascriptData()];
            case 1:
                javascriptData = _b.sent();
                return [4 /*yield*/, exports.getHDM()];
            case 2:
                hdmJavascriptData = _b.sent();
                return [2 /*return*/, {
                        javascriptData: javascriptData,
                        hdmJavascriptData: hdmJavascriptData,
                    }];
            case 3:
                _a = _b.sent();
                throw new Error('Failed to retrieve device data!');
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getAllDeviceData = getAllDeviceData;
//# sourceMappingURL=getAllDeviceData.js.map